import PageLayout from "@/components/PageLayout";
import PageHero from "@/components/PageHero";
import TechniqueCards from "@/components/TechniqueCards";
import heroImg from "@/assets/druktechnieken/druktechnieken-hero.webp";

const hero = (
  <PageHero
    image={heroImg}
    alt="DTF printing bij Magic Print"
    title="Druktechnieken"
    subtitle="Van zeefdruk tot DTF printing — wij hebben voor iedere opdracht de juiste textielbedrukking."
  />
);

const Druktechnieken = () => (
  <PageLayout
    title="Druktechnieken"
    metaDescription="Overzicht van alle druktechnieken bij Magic Print: borduren, DTF printing, zeefdruk en transferdruk. Welke techniek past het beste bij uw opdracht?"
    hero={hero}
    ogImage={heroImg}

  >
    <p className="text-lg text-muted-foreground mb-6 leading-relaxed">
      Wilt u textiel laten bedrukken of borduren met uw (bedrijfs)logo, tekst of afbeelding? Dan bent u bij Magic Print aan het juiste adres. In onze drukkerij bieden we diverse druktechnieken aan. Of u nu een grote- of kleine oplage wilt laten drukken, we hebben voor iedere opdracht de juiste techniek.
    </p>
    <p className="text-muted-foreground mb-12 leading-relaxed">
      Producten die u onder andere bij ons kunt laten bedrukken zijn: bedrijfskleding, sportkleding, tassen, caps, jassen, polo's, werkschoenen, t-shirts en handdoeken. Of u nu zakelijk wilt bestellen, of particulier — alles is mogelijk. Wist u dat het aanschaffen van bedrijfskleding fiscaal aftrekbaar is? Een borst- en ruglogo (tenminste 70 cm²) is vaak al voldoende om de kosten ten laste te brengen van uw bedrijf.
    </p>

    <TechniqueCards />
  </PageLayout>
);

export default Druktechnieken;
